import { render, staticRenderFns } from "./AvenantTypeList.vue?vue&type=template&id=5d3b3d5d&scoped=true"
import script from "./AvenantTypeList.vue?vue&type=script&lang=ts"
export * from "./AvenantTypeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b3d5d",
  null
  
)

export default component.exports